import {BasicClientInfoType, CreateAddress, SearchAccountType} from "../interface";

// 기본값 정의
export const defaultBasicClientInfo: BasicClientInfoType = {
    accountId: "",
    billingFlag: "",
    businessRegNo: "",
    customerCategory: "",
    customerType: "",
    industryCategory: "",
    location: "",
    name: "",
    newDTotCredit: 0,
    newIDtRcpDd: 0,
    newLAccountErpValue: "", // ERP 거래처 ID
    newLIndustryGlobalValue: "",
    newPCustomerCategory: 0,
    newPCustomerType: 0,
    newPFgBill: "",
    newPLocation: 0,
    newPTpRcpDd: 0,
    newTxtCdPartner: "", // ERP 거래처 코드
    newTxtDcAds1D: "",
    newTxtDcAds1H: "",
    newTxtNameEng: "",
    newTxtNmCeo: "",
    newTxtNmPartner: "",
    parentAccount: "",
    parentAccountIdValue: null,
    receiptType: "",
    tierInfo: "",
    businessFileInfo: null,
    newTxtNoTel: "",
};

export const defaultShipmentInfo: SearchAccountType = {
    accountId: "", // 거래처 ID
    accountShipmentInfoId: 0, // pk
    addressName: "", // 발송지 주소명
    application: "", // application
    applicationName: "", // application 이름
    contactPerson: "", // 담당자
    contactPersonName: "", // 담당자 이름
    deliveryPlace: "", // 납품처 id
    deliveryPlaceName: "", // 납품처 이름
    exchangeRateCondition1: 0, // 환율지정조건1
    exchangeRateCondition2: 0, // 환율지정조건2
    exchangeRateCondition3: 0, // 환율지정조건3
    exchangeRateUnit: 0,// 환율지정조건 소수점
    industryCategory: "", // 산업구분 id
    industryName: "", // 산업구분 이름
    memo: "", // 메모
    orderType: "", // 수주 유형
    orderTypeName: "", // 수주 유형 이름
    recipient: "", // 수신자
    recipientName: "", // 수신자 이름
    regAt: new Date(), // 등록일
    regBy: "", // 등록자 정보
    salesPlace: "", // 매출처
    salesPlaceName: "", // 매출처 이름
    shippingAddress: "", // 발송지 주소 id
    taxChargeName: "", // 세금계산서 담당자명
    taxInvoicePerson: "", // 세금계산서 담당자
    vatType: "", // vat 구분
    vatTypeName: "", // vat 구분 이름
    address1: "", //
    address2: "", //
    wonUnit: 0, // 원화 단가 단위
    recipientMobilephone: "",
    taxChargeEmailAddress: "",
    taxChargeMobilePhone: "",
    endType: "1",
    newTxtCollection: "",
    newTxtNote: "",
    expectedReceiptDate: ""
};

export const createAddressInit: CreateAddress = {
    _new_l_customer_value: "",
    createName: "",
    createdByValue: "",
    createdon: "",
    newName: "",
    new_addressid: "",
    new_txt_line1: "",
    new_txt_line2: "",
    new_txt_postalcode: "",
    statecode: 0,
    statuscode: ""
};